const pageSize = 500;

// 对应APIList
export const downloadApiListConst = {
  operationData: {
    api: '/api/v1/intelligence_pc/mobileIeggGenreMetrics',
    apiParams: {
      start_date: '',
      end_date: '',
      granularity: 'monthly',
      source_metrics: {
        appannie: ['revenue', 'download'],
        sensortower: ['revenue', 'download'],
      },
      region_type: 'market',
      regions: [],
      metrics: ['revenue', 'download'],
      genres: [],
      Platforms: [],
      b_group_by_region: false,
      b_group_by_date: false,
      b_growth_ratio: true,
      b_group_by_platform: true,
      b_group_by_genre: false,
    },
    apiType: 'mobileIeggGenreMetrics',
  },
  byGames: {
    api: '/api/v1/intelligence_pc/mobileGamesPagesIDs',
    apiParams: {
      market: 'us',
      entity_type: 'mobile',
      genre: [],
      data_tag: 'games',
      start_date: '2022-02-01',
      end_date: '2023-01-01',
      page: 1,
      page_size: pageSize,
      order: 'desc',
      order_by: 'annie_revenue',
      granularity: 'monthly',
      sources: ['appannie', 'sensortower'],
    },
    apiType: 'mobileGamesPagesIDs',
  },
  byMainGenre: {
    api: '/api/v1/intelligence_pc/mobileIeggGenreMetrics',
    apiParams: {
      start_date: '',
      end_date: '',
      granularity: 'monthly',
      source_metrics: {
        appannie: ['revenue', 'download'],
        sensortower: ['revenue', 'download'],
      },
      region_type: 'market',
      regions: [],
      metrics: ['revenue', 'download'],
      genres: [],
      Platforms: [],
      b_group_by_region: false,
      b_group_by_date: false,
      b_growth_ratio: true,
      b_group_by_platform: true,
      b_group_by_genre: false,
    },
    apiType: 'mobileIeggGenreMetrics',
  },
  bySubGenre: {
    api: '/api/v1/intelligence_pc/mobileIeggGenreMetrics',
    apiParams: {
      start_date: '',
      end_date: '',
      granularity: 'monthly',
      source_metrics: {
        appannie: ['revenue', 'download'],
        sensortower: ['revenue', 'download'],
      },
      region_type: 'market',
      regions: [],
      metrics: ['revenue', 'download'],
      genres: [],
      Platforms: [],
      b_group_by_region: false,
      b_group_by_date: false,
      b_growth_ratio: true,
      b_group_by_platform: true,
      b_group_by_genre: false,
    },
    apiType: 'mobileIeggGenreMetrics',
  },
  byCompanies: {
    api: '/api/v1/intelligence_pc/mobileCompanyPagesIDs',
    apiParams: {
      entity_type: 'mobile',
      start_date: '2024-08-01',
      end_date: '2024-09-01',
      granularity: 'monthly',
      market: 'us',
      order: 'desc',
      b_ratio: false,
      order_source: 'appannie',
      order_metric: 'revenue',
      page: 1,
      page_size: pageSize,
      sources: ['appannie'],
    },
    apiType: 'mobileGamesPagesIDs',
  },
} as any;

// sheet页签列表
export const sheetNameList = [
  {
    typeName: 'Operation Data',
    typeValue: 'operation',
    apiType: 'mobileIeggGenreMetrics',
    pipeFrontList: [
      {
        title: 'Date',
        valueKey: 'date',
      },
    ],
    pipeMetricList: [
      {
        title: 'Revenue(appannie)',
        valueKey: 'revenue',
        source: 'appannie',
      },
      {
        title: 'Revenue(sensortower)',
        valueKey: 'revenue',
        source: 'sensortower',
      },
      {
        title: 'Download(appannie)',
        valueKey: 'download',
        source: 'appannie',
      },
      {
        title: 'Download(sensortower)',
        valueKey: 'download',
        source: 'sensortower',
      },
    ],
    pipeInLoopList: [],
    metricKey: '',
    api: '/api/v1/intelligence_pc/mobileIeggGenreMetrics',
    params: {},
  },
  {
    typeName: 'Game Data',
    typeValue: 'games',
    pipeFrontList: [
      {
        title: 'Game Name',
        valueKey: 'name',
        isFixed: true,
      },
      {
        title: 'CompanyName',
        valueKey: 'publisher',
        isFixed: true,
      },
      {
        title: 'Company HQ',
        valueKey: 'publisher_addr',
        isFixed: true,
      },
      {
        title: 'Company HQ Name',
        valueKey: 'publisher_addr_full_name',
        isFixed: true,
      },
      {
        title: 'Parent Company',
        valueKey: 'parent_developer',
        isFixed: true,
      },
      {
        title: 'IEGG Main Genre',
        valueKey: 'iegg_genre',
        isFixed: true,
      },
      {
        title: 'Release Date',
        valueKey: 'release_time',
        isFixed: true,
      },
      {
        title: 'Date',
        valueKey: 'date',
      },
    ],
    pipeMetricList: [
      {
        title: 'Revenue(appannie)',
        valueKey: 'revenue',
        source: 'appannie',
      },
      {
        title: 'Revenue(sensortower)',
        valueKey: 'revenue',
        source: 'sensortower',
      },
      {
        title: 'Download(appannie)',
        valueKey: 'download',
        source: 'appannie',
      },
      {
        title: 'Download(sensortower)',
        valueKey: 'download',
        source: 'sensortower',
      },
      {
        title: 'Mau(appannie)',
        valueKey: 'mau',
        source: 'appannie',
      },
      {
        title: 'Mau(sensortower)',
        valueKey: 'mau',
        source: 'sensortower',
      },
    ],
    pipeInLoopList: [],
    metricKey: '',
    api: '',
    params: {},
  },
  {
    typeName: 'Main Genre Data',
    typeValue: 'main_genres',
    pipeFrontList: [
      {
        title: 'Genre',
        valueKey: 'genre',
        isFixed: true,
      },
      {
        title: 'Date',
        valueKey: 'date',
      },
    ],
    pipeMetricList: [
      {
        title: 'Revenue(appannie)',
        valueKey: 'revenue',
        source: 'appannie',
      },
      {
        title: 'Revenue(sensortower)',
        valueKey: 'revenue',
        source: 'sensortower',
      },
      {
        title: 'Download(appannie)',
        valueKey: 'download',
        source: 'appannie',
      },
      {
        title: 'Download(sensortower)',
        valueKey: 'download',
        source: 'sensortower',
      },
    ],
    pipeInLoopList: [],
    metricKey: '',
    api: '',
    params: {},
  },
  {
    typeName: 'Companies',
    typeValue: 'companies',
    pipeFrontList: [
      {
        title: 'Rank',
        valueKey: 'rank',
        isFixed: true,
      },
      {
        title: 'CompanyName',
        valueKey: 'name',
        isFixed: true,
      },
      {
        title: 'City',
        valueKey: 'location_identifiers_city',
        isFixed: true,
      },
      {
        title: 'Country',
        valueKey: 'location_identifiers_country',
        isFixed: true,
      },
      {
        title: 'Date',
        valueKey: 'date',
      },
    ],
    pipeMetricList: [
      {
        title: 'Revenue(appannie)',
        valueKey: 'revenue',
        source: 'appannie',
      },
      {
        title: 'Revenue(sensortower)',
        valueKey: 'revenue',
        source: 'sensortower',
      },
      {
        title: 'Download(appannie)',
        valueKey: 'download',
        source: 'appannie',
      },
      {
        title: 'Download(sensortower)',
        valueKey: 'download',
        source: 'sensortower',
      },
    ],
    pipeInLoopList: [],
    metricKey: '',
    api: '',
    params: {},
  },
];
